import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("sale_budget")
export class SaleBudgetEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"id"
    }) 
    id: number;

    @Column('int',{
        name:'sale_person_id',
        nullable:false
    })
    salePersonId:number
    @Column('int',{
        name:'no_of_containers',
        nullable:false
    })
    noOfContainers:number

    @Column('varchar',{
        name:'month',
        nullable:false,
        length:50
    })
    month:string

    @Column('varchar',{
        name:'year',
        nullable:false,
        length:50
    })
    year:string

   
    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
        
   
}